import { Component, Input } from '@angular/core'
import { ContentResultItem } from '../../types'

@Component({
  selector: 'mb-cms-search-result-item-wrapper',
  templateUrl: './cms-search-result-item-wrapper.component.html',
  styleUrls: ['./cms-search-result-item-wrapper.component.scss']
})
export class CmsSearchResultItemWrapperComponent {
  @Input() result: ContentResultItem | undefined
  @Input() additionalInfo: string | undefined
}
